/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import SignUpService from "../services/SignupService";

export function create(email: string, password: string, partnerID: any, programID: string) {
    return async () => {
        try {
            const response = await SignUpService.create(email, password, partnerID as string, programID);
            const { token } = response.data;
            if (token !== '') {
                localStorage.setItem('token', response.data.token as string);
                window.location.href = "/app/dashboard";
            } else {
                window.location.href = "/registered";
            }
        } catch (error) {
            throw error;
        }
    }
}
